import { MessageSquare } from 'lucide-react';

export function Footer({ t }: { t: any }) {
  return (
    <footer className="bg-zinc-950 border-t border-white/10" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Footer</h2>
      <div className="mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-24 lg:px-8 lg:pt-32">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8">
            <div className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-emerald-500/10">
                <MessageSquare className="h-5 w-5 text-emerald-500" />
              </div>
              <span className="text-lg font-bold tracking-tight text-white">Totemium</span>
            </div>
            <p className="text-sm leading-6 text-zinc-400">
              {t.footer.tagline}
            </p>
            <div className="flex space-x-6">
               {/* Social links placeholders */}
            </div>
          </div>
          <div className="mt-16 grid grid-cols-2 gap-8 xl:col-span-2 xl:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-white">{t.footer.columns.product}</h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li><a href="#features" className="text-sm leading-6 text-zinc-400 hover:text-white">{t.footer.links.features}</a></li>
                  <li><a href="#pricing" className="text-sm leading-6 text-zinc-400 hover:text-white">{t.footer.links.pricing}</a></li>
                  <li><a href="#" className="text-sm leading-6 text-zinc-400 hover:text-white">{t.footer.links.integrations}</a></li>
                </ul>
              </div>
              <div className="mt-10 md:mt-0">
                <h3 className="text-sm font-semibold leading-6 text-white">{t.footer.columns.support}</h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li><a href="#" className="text-sm leading-6 text-zinc-400 hover:text-white">{t.footer.links.docs}</a></li>
                  <li><a href="#" className="text-sm leading-6 text-zinc-400 hover:text-white">API Status</a></li>
                  <li><a href="#" className="text-sm leading-6 text-zinc-400 hover:text-white">{t.footer.links.contact}</a></li>
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-sm font-semibold leading-6 text-white">{t.footer.columns.legal}</h3>
                <ul role="list" className="mt-6 space-y-4">
                  <li><a href="#" className="text-sm leading-6 text-zinc-400 hover:text-white">{t.footer.links.privacy}</a></li>
                  <li><a href="#" className="text-sm leading-6 text-zinc-400 hover:text-white">{t.footer.links.terms}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 border-t border-white/10 pt-8 sm:mt-20 lg:mt-24">
          <p className="text-xs leading-5 text-zinc-500">&copy; {new Date().getFullYear()} Totemium AI. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
